import React from "react";
import client from "@culturehq/client";
import { areEventsEnabled, arePostsEnabled, t, Trans } from "app/utils";
import { useProfile } from "app/context";
import { Icon, Panel, PlainButton } from "@culturehq/components";
import ErrorBoundary from "components/common/ErrorBoundary";

const Step = ({ step, number }) => (
  <p className="GettingStarted__Step">
    <span className="GettingStarted__Step--number">{number}</span>
    <span className="GettingStarted__Step--description">{step}</span>
  </p>
);

const GettingStarted = () => {
  const { profile, fetchedProfile } = useProfile();

  const getPostLabel = () => {
    if (arePostsEnabled(profile)) {
      if (!areEventsEnabled(profile)) {
        return ", or post";
      }
      return ", post";
    }

    return "";
  };

  const steps = [
    t("Search and select tags by interest, skill, department, etc."),
    t("Explore all people and content relevant to those tags."),
    t(`Add content by sharing a new story${getPostLabel()}${areEventsEnabled(profile) ? ", or creating an event" : ""}`)
  ];

  const handleCloseButton = async () => {
    const { profile: updatedProfile } = await client.removeGettingStarted();
    fetchedProfile({ ...updatedProfile, organization: profile.organization });
  };

  if (!profile.showGettingStartedWidget) {
    return <></>;
  }

  return (
    <Panel className="SidePanel GettingStarted">
      <Panel.Heading>
        <Icon icon="rocket" />
        {" "}
        <Trans>Getting Started</Trans>
        <PlainButton className="close-button" onClick={() => handleCloseButton()}><Icon icon="close" /></PlainButton>
      </Panel.Heading>
      <Panel.Body>
        <ErrorBoundary>
          {steps.map((step, index) => (
            <Step
              key={index}
              number={index + 1}
              step={step}
            />
          ))}
        </ErrorBoundary>
      </Panel.Body>
    </Panel>
  );
};

export default GettingStarted;
